import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import { BsCalendarEvent, BsEye } from "react-icons/bs";
import { useNavigate } from "react-router";
import { PopUpModalButton } from "../../../../../components/basic/ModalComponent";
import { useAuth } from "../../../../../context/auth";
import { getURLbyEndPoint, getURLbyEndPointV2 } from "../../../../../store/api";
import { getAuthUserlocal } from "../../../../../store/services";
import { bankNames } from "../../../../auth/Register/RegisterPage3";

const SlotBooking = ({ selectedSlots, setActiveGlobalTab, onSlotRemove }) => {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showSlotsModal, setShowSlotsModal] = useState(false);
  const [selectedPaymentSlots, setSelectedPaymentSlots] = useState([]);
  const totalAmount = selectedSlots.reduce((sum, slot) => sum + slot.price, 0);

  // Add state for terms and conditions
  const [termsAccepted, setTermsAccepted] = useState({
    readUnderstood: false,
    abideRules: false,
    introductoryNature: false,
    basicGuidance: false
  });

  const userId = getAuthUserlocal()._id;

  // Check if all terms are accepted
  const allTermsAccepted = Object.values(termsAccepted).every(value => value === true);

  // Handle checkbox changes
  const handleCheckboxChange = (key) => {
    setTermsAccepted(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Fetch payment history when component mounts or userId changes
  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axios.get(
          `${getURLbyEndPointV2("getB2bBookingHistory") + userId}`
        );
        if (response.data.data) {
          setPaymentHistory(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching payment history:", error);
      }
    };

    if (userId && selectedSlots.length === 0) {
      fetchPayments();
    }
  }, [userId, selectedSlots.length]);

  // Handle showing the slots modal with details for a specific payment
  const handleShowSlots = (slots) => {
    setSelectedPaymentSlots(slots);
    setShowSlotsModal(true);
  };

  const handleCloseSlots = () => setShowSlotsModal(false);

  return (
    <div className="p-2">
      {selectedSlots.length > 0 ? (
        selectedSlots.map((slot, index) => (
          <Card key={index} className="mb-2">
            <Card.Body className="d-flex justify-content-between">
              <div>
                <h6>{slot.countryName} - {slot.companyName}</h6>
                <p>
                  {new Date(slot.date).toISOString().split("T")[0]} |{" "}
                  {slot.startTime} - {slot.endTime} | {slot.duration} mins
                </p>
                <p>
                  <strong>Price:</strong> ₹ {slot.price}
                </p>
              </div>
              <div>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => onSlotRemove(slot.slotId)}
                >
                  Remove
                </Button>
              </div>
            </Card.Body>
          </Card>
        ))
      ) : (
        <div>
          <h5>Slot and Payment</h5>
          <hr/>
          {paymentHistory.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>App No</th>
                  <th>Payment Date</th>
                  <th>Slots</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((data, index) => (
                  <tr key={index}>
                    <td>{data.appNo || "N/A"}</td>
                    <td>
                      {new Date(data.paymentDate).toLocaleDateString()}
                    </td>
                    <td>
                      {data.slots && data.slots.length > 0 ? (
                        <>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowSlots(data.slots)}
                          >
                            Details
                          </Button>
                        </>
                      ) : (
                        "No slots"
                      )}
                    </td>
                    <td>₹{data.amount}</td>
                    <td>{data.paymentStatus}<br />
                      {data.receipt &&
                        <PopUpModalButton
                          title="receipt"
                          fileLink={data.receipt}
                        />
                      }
                    </td>
                    <td>{data.remark || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Container className="d-flex justify-content-center align-items-center my-2 text-center">
              <div>
                <BsCalendarEvent  size={40} className="mb-2"  style={{color: 'blue'}} />
                <h3 className='fw-bold' style={{color: 'blue'}}>Slot not yet booked</h3>
                <p>please select your slot.</p>
              </div>
            </Container>
          )}
        </div>
      )}

      {selectedSlots.length > 0 && (
        <div className="mt-3">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>₹{totalAmount}</td>
              </tr>
            </tbody>
          </Table>
          {/* Add Terms and Conditions Checkboxes */}
          <Form>
            <div className="mb-3 mx-3">
              <Form.Check
                required
                label="I confirm that I have read and understood the terms and conditions of the B2B forum."
                checked={termsAccepted.readUnderstood}
                onChange={() => handleCheckboxChange('readUnderstood')}
                isInvalid={!termsAccepted.readUnderstood}
                feedback="You must agree to the terms and conditions before proceeding."
              />
              <Form.Check
                required
                label="I agree to abide by the rules and regulations set by the B2B forum."
                checked={termsAccepted.abideRules}
                onChange={() => handleCheckboxChange('abideRules')}
                isInvalid={!termsAccepted.abideRules}
                feedback="You must agree to follow the rules before proceeding."
              />
              <Form.Check
                required
                label="I acknowledge and understand that this meeting with a foreign collaborator is of introductory nature."
                checked={termsAccepted.introductoryNature}
                onChange={() => handleCheckboxChange('introductoryNature')}
                isInvalid={!termsAccepted.introductoryNature}
                feedback="You must acknowledge the introductory nature of the meeting."
              />
              <Form.Check
                required
                label="I understand that, the meeting will give me only the basic guidance about the target market environment, potential, regulatory compliance, trade disputes or IPR issues. Whereas availing such services in future will be payable and may be negotiated with the expert collaborator on agreeable terms & conditions."
                checked={termsAccepted.basicGuidance}
                onChange={() => handleCheckboxChange('basicGuidance')}
                isInvalid={!termsAccepted.basicGuidance}
                feedback="You must understand the scope and limitations of the meeting."
              />
            </div>
          </Form>
          <div className="text-center d-flex gap-3 justify-content-center">
            <Button
              variant="primary"
              size="sm"
              onClick={() => setActiveGlobalTab("Participants countries")}
            >
              Add more slots
            </Button>
            <PaymentProcess
              totalAmount={totalAmount}
              slots={selectedSlots}
              termsAccepted={allTermsAccepted}
            />
          </div>
        </div>
      )}

      {/* Slots Details Modal */}
      <Modal
        show={showSlotsModal}
        onHide={handleCloseSlots}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Slot Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPaymentSlots.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Country</th>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Duration (mins)</th>
                  <th>Price (₹)</th>
                </tr>
              </thead>
              <tbody>
                {selectedPaymentSlots.map((slot, index) => (
                  <tr key={index}>
                    <td>{slot.country}</td>
                    <td>{new Date(slot.date).toLocaleDateString()}</td>
                    <td>{slot.startTime}</td>
                    <td>{slot.endTime}</td>
                    <td>{slot.duration || "N/A"}</td>
                    <td>{slot.price || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No slot details available.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SlotBooking;



function PaymentProcess({ totalAmount, slots, termsAccepted }) {
  const [modalShow, setModalShow] = useState(false);
  const [addAmount, setAddAmount] = useState(false);
  const [apiSubmitPayment, setApiSubmitPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [auth, setAuth] = useAuth();
  const userId = auth ? auth.user : null;

  const [formFlag, setFormFlag] = useState(false);
  const [formData, setFormData] = useState({
    utrNo: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    amount: totalAmount,
    paymentScreenShot: null,
  });
  const navigate = useNavigate();

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  const user = getAuthUserlocal();
  const walletBalance = user.balance;

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleFileUpload = (field, file) => {
    if (file.size <= 3 * 1024 * 1024) {
      setFormData((prevData) => ({
        ...prevData,
        [field]: file,
      }));
    } else {
      console.error("File size exceeds 3MB");
      alert("File size exceeds 3MB");
    }
  };

  const handleConfirmPayment = async () => {
    setIsLoading(true)
    const debitAmount = totalAmount;
    const userId = getAuthUserlocal()._id;

    if (debitAmount === 0) {
      setAddAmount(false);
    } else if (walletBalance < debitAmount) {
      setAddAmount(true);
      return;
    }

    try {
      setIsLoading(true)
      const res = await axios.post(
        getURLbyEndPointV2("processB2bPayment") + userId,
        { debitAmount }
      );

      if (res.data.success) {
        setIsLoading(false)
        alert("Payment processed and slots booked successfully!");
        window.location.reload();
        setApiSubmitPayment(true);
      }
    } catch (error) {
      console.error("Error during payment confirmation:", error);
      setIsLoading(false)
    } finally {
      setApiSubmitPayment(false);
      setIsLoading(false)
    }
  };


  const handleAddFund = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    setFormFlag(true);
    const validationRulesProceedPayment = {
      utrNo: {
        message: "Please Enter UTR Number.",
        isValid: () => formData.utrNo.trim() !== "",
      },
      amount: {
        message: "Please Enter Amount.",
        isValid: () =>
          formData.amount !== 0 && formData.amount.toString()[0] !== "0",
      },
      amountMin: {
        message: "Please Enter Amount More Than 500.",
        isValid: () => formData.amount >= 500,
      },
      paymentScreenShot: {
        message: "Please Enter Payment Screenshot.",
        isValid: () => formData.paymentScreenShot !== null,
      },

    };

    for (const field in validationRulesProceedPayment) {
      const { message, isValid } = validationRulesProceedPayment[field];
      if (!isValid()) {
        alert(message);
        setFormFlag(false);
        return;
      }
    }

    const apiFormData = new FormData();
    apiFormData.append("utrNo", formData.utrNo);
    apiFormData.append("amount", formData.amount);
    apiFormData.append("bankName", formData.bankName);
    apiFormData.append("ifscCode", formData.ifscCode);
    apiFormData.append("accountNumber", formData.accountNumber);
    apiFormData.append("paymentScreenShot", formData.paymentScreenShot);
    apiFormData.append("clientId", userId);
    apiFormData.append('slots', JSON.stringify(slots));
    try {
      const res = await axios.post(
        getURLbyEndPoint("addB2bFundToWallet") + userId,
        apiFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status) {
        alert(res.data.message);
        setFormData({
          utrNo: "",
          amount: totalAmount,
          paymentScreenShot: null,
        });
        setAddAmount(false);
        setFormFlag(false);
        setIsLoading(false);
        window.location.reload();
      } else {
        alert("Something went wrong!");
        setIsLoading(false);
      }
    } catch (error) {
      let errorMessage = "Server is not responding!!";

      if (error.response) {
        console.error("Response error:", error.response.data);
        console.error("Status code:", error.response.status);
        errorMessage = error.response.data.error || errorMessage;
        errorMessage = errorMessage.split("; ").join("\n");
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
      alert(errorMessage);
      setIsLoading(false);
    } finally {
      setFormFlag(false);
      setIsLoading(false);
    }
  };

  // Set default values when modal opens
  useEffect(() => {
    if (modalShow && addAmount) {
      setFormData((prevData) => ({
        ...prevData,
        amount: totalAmount,
      }));
    }
  }, [modalShow, addAmount]);

  return (
    <>
      <Button
        variant="success"
        size='sm'
        onClick={handleShow}
        disabled={!termsAccepted}
      >
        Process Payment
      </Button>

      <Modal show={modalShow} onHide={handleClose} size='lg' centered>
        <Modal.Body>
          <div>
            <h5>Payment Process</h5>
            <hr />
            <Card>
              <Card.Header>
                <Row className="d-flex">
                  <Col md={7}>
                    <h6 className="text-medium">{user.companyName}</h6>
                    <h6 className="text-medium">Membership No: {user.memberShipNo}</h6>
                  </Col>
                  <Col md={5}>
                    <h6 className="text-medium">Wallet Balance: ₹{walletBalance}</h6>
                    <h6 className="text-medium">Valid Upto: {user.validUpTo}</h6>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                {!addAmount ? (
                  <>
                    <div className="ms-5 mb-2">
                      <div className="fw-semibold fs-6">
                        Debit Amount: ₹{totalAmount} /-
                      </div>
                      <div className="fw-semibold fs-6">
                        Payment Towards: Event And Seminar Wing
                      </div>
                    </div>
                    <Card className="p-2 mb-3">
                      <Card.Text className="fs-5 mb-0">Informative Note:</Card.Text>
                      <ul>
                        <li>Initiate wallet payments only from the company&#39;s registered and authorized bank account.</li>
                        <li>The beneficiary Account displayed on this platform is unique to you only and should not be shared with anyone else.</li>
                        <li>In Case of Rejection, Amount will be Credited to your wallet.</li>
                        <li>You can monitor Transaction entries in your wallet.</li>
                        <li>For Any Assistance, contact Chamber Desk.</li>
                      </ul>
                    </Card>
                    <div className="text-center">
                      {totalAmount > 0 ? (
                        walletBalance < totalAmount ? (
                          <Button
                            variant="success"
                            className="rounded-5 px-5 text-medium"
                            onClick={() => setAddAmount(true)}
                          >
                            Add Balance
                          </Button>
                        ) : (
                          <Button
                            variant="success"
                            className="rounded-5 px-5 text-medium"
                            onClick={handleConfirmPayment}
                            disabled={!termsAccepted}
                          >
                            CONFIRM PAYMENT
                          </Button>
                        )
                      ) : (
                        <Button
                          variant="success"
                          className="rounded-5 px-5 text-medium"
                          onClick={handleConfirmPayment}
                          disabled={!termsAccepted}
                        >
                          CONFIRM PAYMENT
                        </Button>
                      )}
                    </div>

                  </>
                ) : (
                  <Form className="mb-3" onSubmit={handleAddFund}>
                    <div className="mb-3 d-flex justify-content-between">
                      <h5>Add Amount</h5>
                      <a href="#" onClick={() => navigate('/wallet')}>Show History</a>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>UTR NO.</h6>
                      <Form.Control
                        className="w-75"
                        type="text"
                        placeholder="Enter Utr No."
                        required
                        value={formData.utrNo}
                        onChange={(e) =>
                          handleInputChange("utrNo", e.target.value)
                        }
                        maxLength={25}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Bank Name.</h6>
                      <Form.Select
                        className="w-75"
                        onChange={(e) =>
                          handleInputChange("bankName", e.target.value)
                        }
                        value={formData.bankName}
                        name="bankName"
                      >
                        <option value="">Select a bank</option>
                        {bankNames.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Account Number.</h6>
                      <Form.Control
                        className="w-75"
                        type="text"
                        placeholder="Enter your bank account number."
                        required
                        value={formData.accountNumber}
                        onChange={(e) =>
                          handleInputChange("accountNumber", e.target.value)
                        }
                        maxLength={25}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>IFSC.</h6>
                      <Form.Control
                        className="w-75"
                        type="text"
                        placeholder="Enter IFSC code."
                        required
                        value={formData.ifscCode}
                        onChange={(e) =>
                          handleInputChange("ifscCode", e.target.value)
                        }
                        maxLength={25}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>AMOUNT</h6>
                      <Form.Control
                        className="w-75"
                        type="text"
                        maxLength={6}
                        placeholder="Enter Amount"
                        required
                        value={totalAmount}
                        disabled
                      />
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <h6 className="me-3">PAYMENT Screenshot (MAX 3MB)</h6>
                      <div className="me-3">
                        <label
                          className={
                            formData.paymentScreenShot
                              ? "btn btn-success"
                              : "btn btn-primary"
                          }
                          htmlFor="paymentScreenShot"
                        >
                          {formData.paymentScreenShot
                            ? "Uploaded"
                            : "Choose File"}
                        </label>
                        <input
                          style={{ display: "none" }}
                          type="file"
                          accept="image/*"
                          name="paymentScreenShot"
                          id="paymentScreenShot"
                          onChange={(e) =>
                            handleFileUpload("paymentScreenShot", e.target.files[0])
                          }
                        />
                      </div>
                      {formData.paymentScreenShot && (
                        <a
                          href={URL.createObjectURL(formData.paymentScreenShot)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <BsEye className="icon-size" />
                        </a>
                      )}
                    </div>
                    <div className="text-center">
                      <Button
                        variant="success"
                        className="px-5"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? `loading...` : `Proceed Payment`}
                      </Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}